import Vue from 'vue'
import Router from 'vue-router'
//import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import CategoryCreate from '../views/CategoryCreate.vue';
import NewsCate from '../views/NewsCate.vue'
import BannerCate from '../views/BannerCate.vue'
//import CategoryEdit from '../views/CategoryEdit.vue'
import CategorySchool from '../views/CategorySchool.vue';
import TeacherCreate from '../views/TeacherCreate.vue';
import TeacherList from '../views/TeacherList.vue';
import TeacherEdit from '../views/TeacherEdit.vue';

import LessonCreate from '../views/LessonCreate.vue'
import LessonList from '../views/LessonList.vue'
import LessonEdit from '../views/LessonEdit.vue'

import ContentCreate from '../views/ContentCreate.vue'
import ContentList from '../views/ContentList.vue'
import ContentEdit from '../views/ContentEdit.vue'

import Units from '../views/Units.vue';

import TestVideoCreate from '../views/TestVideoCreate.vue'
import TestVideoList from '../views/TestVideoList.vue'
import TestVideoEdit from '../views/TestVideoEdit.vue'


import TestsCreate from '../views/TestsCreate.vue'
import TestsList from '../views/TestsList.vue'
import TestsEdit from '../views/TestsEdit.vue'

import PriceCreate from '../views/PriceCreate.vue'
import PriceList from '../views/PriceList.vue'
import PriceEdit from '../views/PriceEdit.vue'

//import CategoryPriceEdit from '../views/CategoryPriceEdit.vue'
import GradeCreate from '../views/GradeCreate.vue'
import GradeList from '../views/GradeList.vue'
import GradeEdit from '../views/GradeEdit.vue'


//import AddContent from '../views/AddContent.vue'
//import AddSummary from '../views/AddSummary.vue'

import NewsCreate from '../views/NewsCreate.vue'
import NewsList from '../views/NewsList.vue'
import NewsEdit from '../views/NewsEdit.vue'

import TimelineCreate from '../views/TimeLineCreate.vue'
import TimelineList from '../views/TimeLineList.vue'
import TimelineEdit from '../views/TimeLineEdit.vue'

import OutlineCreate from '../views/OutlineCreate.vue'
import OutlineList from '../views/OutlineList.vue'
import OutlineEdit from '../views/OutlineEdit.vue'

import GuideCreate from '../views/GuideCreate.vue'
import GuideList from '../views/GuideList.vue'
import GuideEdit from '../views/GuideEdit.vue'

import AdviceCreate from '../views/AdviceCreate.vue'
import AdviceList from '../views/AdviceList.vue'
import AdviceEdit from '../views/AdviceEdit.vue'

import FilesCreate from '../views/FilesCreate.vue'
import FilesList from '../views/FilesList.vue'
import FilesEdit from '../views/FilesEdit.vue'

import BooksCreate from '../views/BooksCreate.vue'
import BooksList from '../views/BooksList.vue'
import BooksEdit from '../views/BooksEdit.vue'

//import AddBooks from '../views/AddBooks.vue'
import AboutCreate from '../views/AboutCreate.vue'
import AboutList from '../views/AboutList.vue'

import AdminUser from '../views/AdminUser.vue'

import BannerCreate from '../views/BannerCreate.vue'
import BannerEdit from '../views/BannerEdit.vue'
import BannerList from '../views/BannerList.vue'

import NewsBannerCreate from '../views/NewsBannerCreate .vue'
import NewsBannerEdit from '../views/NewsBannerEdit.vue'
import NewsBannerList from '../views/NewsBannerList.vue'

import Login from '../views/Login.vue'


Vue.use(Router)

const router = new Router(

  {
    base: '/',
    mode: 'history',

    routes: [{
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { isValidate: true }
    },
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [{
        path: '/admin/user',
        name: 'AdminUser',
        component: AdminUser,
      },
      {
        path: '/categories/school',
        component: CategorySchool
      },
      {
        path: '/news/cate',
        component: NewsCate
      }, {
        path: '/banner/cate',
        component: BannerCate
      },
      {
        path: '/teacher/create',
        component: TeacherCreate,
      },
      {
        path: '/teacher/list',
        component: TeacherList,
      },
      {
        path: '/teacher/edit/:id',
        component: TeacherEdit,
        props: true
      },
      {
        path: '/categories/create',
        component: CategoryCreate
      },
      /* {
        path: '/categories/edit/:id',
        component: CategoryEdit
      }, */
      {
        path: '/grade/create',
        component: GradeCreate
      },
      {
        path: '/grade/list',
        component: GradeList
      },
      {
        path: '/grade/edit/:id',
        component: GradeEdit,
        props: true
      },
      {
        path: '/timeline/create',
        component: TimelineCreate
      },
      {
        path: '/timeline/list',
        component: TimelineList
      },
      {
        path: '/timeline/edit/:id',
        component: TimelineEdit,
        props: true
      },

      {
        path: '/price/create',
        component: PriceCreate
      },
      {
        path: '/price/list',
        component: PriceList
      },
      {
        path: '/price/edit/:id',
        component: PriceEdit,
        props: true
      },
      /* {
        path: '/lesson/addcontent/:id',
        component: AddContent,
        props: true
      }, */
      {
        path: '/content/units/:id',
        component: Units,
        props: true
      },
      {
        path: '/lesson/list',
        component: LessonList
      },
      {
        path: '/lesson/create',
        component: LessonCreate
      },
      {
        path: '/lesson/edit/:id',
        component: LessonEdit,
        props: true
      },
      {
        path: '/content/create',
        component: ContentCreate
      }, {
        path: '/content/list',
        component: ContentList
      },
      {
        path: '/content/edit/:id',
        component: ContentEdit,
        props: true
      },
      {
        path: '/tvideo/create',
        component: TestVideoCreate
      }, {
        path: '/tvideo/list',
        component: TestVideoList
      },
      {
        path: '/tvideo/edit/:id',
        component: TestVideoEdit,
        props: true
      },
      {
        path: '/tests/list',
        component: TestsList
      },
      {
        path: '/tests/create',
        component: TestsCreate
      },
      {
        path: '/tests/edit/:id',
        component: TestsEdit,
        props: true
      },
      /* {
  
        path: '/categories/addbooks',
        name: AddBooks,
        component: AddBooks,
  
      }, */
      {
        path: '/banner/create',
        component: BannerCreate,
      },
      {
        path: '/banner/edit/:id',
        component: BannerEdit,
        props: true
      },
      {
        path: '/banner/list',
        component: BannerList,
      },
      {
        path: '/newsbanner/create',
        component: NewsBannerCreate,
      },
      {
        path: '/newsbanner/edit/:id',
        component: NewsBannerEdit,
        props: true
      },
      {
        path: '/newsbanner/list',
        component: NewsBannerList,
      },
      {
        path: '/news/create',
        component: NewsCreate
      },
      {
        path: '/news/list',
        component: NewsList
      },
      {
        path: '/news/edit/:id',
        component: NewsEdit,
        props: true
      },
      {
        path: '/outline/create',
        component: OutlineCreate
      },
      {
        path: '/outline/list',
        component: OutlineList
      },
      {
        path: '/outline/edit/:id',
        component: OutlineEdit,
        props: true
      },
      {
        path: '/files/create',
        component: FilesCreate
      },
      {
        path: '/files/list',
        component: FilesList
      },
      {
        path: '/files/edit/:id',
        component: FilesEdit,
        props: true
      },
      {
        path: '/books/create',
        component: BooksCreate
      },
      {
        path: '/books/list',
        component: BooksList
      },
      {
        path: '/books/edit/:id',
        component: BooksEdit,
        props: true
      },
      {
        path: '/about/create',
        component: AboutCreate
      },
      {
        path: '/about/list',
        component: AboutList
      },
      {
        path: '/guide/create',
        component: GuideCreate
      },
      {
        path: '/guide/list',
        component: GuideList
      },
      {
        path: '/guide/edit/:id',
        component: GuideEdit,
        props: true
      },
      {
        path: '/advice/create',
        component: AdviceCreate
      },
      {
        path: '/advice/list',
        component: AdviceList
      },
      {
        path: '/advice/edit/:id',
        component: AdviceEdit,
        props: true
      },
      ]
    },
    ]
  })


router.beforeEach((to, from, next) => {
  if (!to.meta.isValidate && !localStorage.token) {
    return next('/login')
  }
  next()
})

export default router